import{createContext as r}from"react";const o=r({color:"currentColor",size:"1em",weight:"regular",mirrored:!1});export{o};
